import React from "react";

const InvalidUrl = () => {
  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f0f0f0",
  };

  const imageStyle = {
    maxWidth: "100%",
    maxHeight: "100%",
  };

  return (
    <div style={containerStyle}>
      <img
        src={require("../assets/404-error.png")}
        alt="404 Error"
        style={imageStyle}
      />
    </div>
  );
};

export default InvalidUrl;


